import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { DisclosureActions } from './disclosure.actions';
import { IDisclosureState } from './disclosure.state';

export const initialDisclosureState: IDisclosureState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const disclosureReducerFn = createReducer(
  initialDisclosureState,
  on(DisclosureActions.reset, (state: IDisclosureState, action) => {
    return new StateBuilder<IDisclosureState>(initialDisclosureState).build();
  }),
  on(DisclosureActions.updateModel, (state: IDisclosureState, action) => {
    const { model } = action;
    return new StateBuilder<IDisclosureState>(state, { model }).toLoading().build();
  }),
  on(DisclosureActions.load, (state: IDisclosureState, action) => {
    return new StateBuilder<IDisclosureState>(state).toLoading().build();
  }),
  on(DisclosureActions.loadSuccess, (state: IDisclosureState, action) => {
    return new StateBuilder<IDisclosureState>(state, action).toLoaded().build();
  }),
  on(DisclosureActions.submit, (state: IDisclosureState, action) => {
    return new StateBuilder<IDisclosureState>(state).toLoading().build();
  }),
  on(DisclosureActions.submitSuccess, (state: IDisclosureState, action) => {
    return new StateBuilder<IDisclosureState>(state, action).toLoaded().build();
  })
);

export function disclosureReducer(state: IDisclosureState | undefined, action: Action) {
  return disclosureReducerFn(state, action);
}
